import React from "react";

import "./App.scss";

import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import blancaImg from "./img/blanca.jpg";
import aeonImg from "./img/aeon.jpg";
import conatusImg from "./img/conatus.png";

function App() {
  return (
    <div className="App">
      <header>
        <Navbar className="bg-body-tertiary">
          <Container>
            <Navbar.Brand href="#home">Luis Mejía</Navbar.Brand>
            <Nav>
              <Nav.Link
                href="#contact"
                onClick={() =>
                  (window.location.href = "mailto:info@luismejia.net")
                }
              >
                Contact
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar>
      </header>

      <Container className="px-3 px-md-4 py-3" id="parent-container">
        <Container className="px-3 py-4 px-md-5 py-md-5 mb-4 rounded-3" id="blanca">
          <Row>
            <Col lg="12">
              <img style={{ width: "100%" }} src={blancaImg} alt="Blanca" />
            </Col>
          </Row>
          <br />

          <Row>
            <Col xs="12" md="3">
              <div style={{ textAlign: "left" }}>
                <h5 className="movie-title">Blanca</h5>
              </div>
            </Col>
            <Col xs="12" md="9">
              <div style={{ textAlign: "left" }}>
                <p>
                  Feature in development
                  <br />
                  90 Minutes
                </p>
              </div>
            </Col>
            <Col xs="12">
              <div style={{ textAlign: "left" }}>
                <h5>Logline</h5>
                <p>
                  A Parisian former model entangled in human trafficking flees
                  to Mexico to escape a criminal organization. A paranoid
                  journey within the psyche of a fugitive, where survival
                  collides with guilt, and the ghosts of her past.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="px-3 py-4 px-md-5 py-md-5 mb-4 rounded-3" id="aeon">
          <Row>
            <Col lg="12">
              <img style={{ width: "100%" }} src={aeonImg} alt="Aeon" />
            </Col>
          </Row>
          <br />

          <Row>
            <Col xs="12" md="3">
              <div style={{ textAlign: "left" }}>
                <h5 className="movie-title">Aeon</h5>
              </div>
            </Col>
            <Col xs="12" md="9">
              <div style={{ textAlign: "left" }}>
                <p>
                  Featurette
                  <br />
                  in Post-production
                </p>
              </div>
            </Col>
            <Col xs="12">
              <div style={{ textAlign: "left" }}>
                <h5>Logline</h5>
                <p>
                  Burdened by the weight of eternity, an unknown being is given
                  a human body to end Its own existence.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="px-3 py-4 px-md-5 py-md-5 mb-4 rounded-3" id="conatus">
          <Row>
            <Col lg="12">
              <img style={{ width: "100%" }} src={conatusImg} alt="Conatus" />
            </Col>
          </Row>
          <br />

          <Row>
            <Col xs="12" md="3">
              <div style={{ textAlign: "left" }}>
                <h5 className="movie-title">Conatus</h5>
              </div>
            </Col>
            <Col xs="12" md="9">
              <div style={{ textAlign: "left" }}>
                <p>
                  Feature in development
                  <br />
                  90 Minutes
                </p>
              </div>
            </Col>
            <Col xs="12">
              <div style={{ textAlign: "left" }}>
                <h5>Logline</h5>
                <p>
                  A troubled middle-aged author journeys through Mexico’s
                  wilderness seeking peace and redemption, but a road incident
                  wakes up haunting visions from the past and ignites a
                  profound existential crisis.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default App;
